module.exports = __webpack_public_path__ + "img/scooter.2915fee4.png";